import PropTypes from "prop-types";
import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import userStore from "data/userStore";
import React from "react";
import Control from "lib/common/descriptorcontrols/FileField/manager";
import {
    buildFileMeta,
    buildFilesForField,
    previewFile,
} from "data/selectors/fileUploads";
import FileUploadStore from "data/FileUploadStore";
import FileUploadActions from "data/FileUploadActions";
import useFluxStore from "@armus/use-flux-store";
import Dispatcher from "Dispatcher";

export class FileFieldmanager extends BaseFormItem {
    constructor(props) {
        super(props);
        this.onFilePreview = this.onFilePreview.bind(this);
        this.onFileUpload = this.onFileUpload.bind(this);
        this.onRemoveFile = this.onRemoveFile.bind(this);
        this.getCompletetedFiles = this.getCompletetedFiles.bind(this);
        this.buildFiles = this.buildFiles.bind(this);
        this.setFileMeta = this.setFileMeta.bind(this);
    }

    buildFiles() {
        const {activeRecord, descriptor} = this.props;
        const completedCollection = this.getCompletetedFiles().map((f) => {
            f._status = Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE;
            return this.setFileMeta(f);
        });
        return buildFilesForField(descriptor.key, activeRecord.id, completedCollection).map(
            // add meta
            (f) => ({
                id: f.id,
                filename: f.filename,
                status: f._status,
                progress: f._progress || 0,
                filesize: f.size,
                model: f
            })
        );
    }

    setFileMeta(file) {
        const {activeRecord, descriptor} = this.props;
        const config = descriptor.config || {};
        const org = userStore.getActiveOrgKey();
        return buildFileMeta(descriptor.key, activeRecord.id, org, activeRecord.entityKey, !!config.multiValued, file);
    };

    getCompletetedFiles() {
        const {activeRecord, descriptor} = this.props;
        let value = activeRecord.get(descriptor.key);
        if(value && !Array.isArray(value)) {
            // always return an array.
            value = [value];
        }
        return value === null ? [] : [...value]; // always return new copy of the array.
    }

    onFileUpload(e, d, files) {
        const { activeRecord, descriptor } = this.props;
        const completedFiles = this.getCompletetedFiles();
        // files is always an array.
        for (let i = 0; i < files.length; i++) {
            const rawFile = files[i];
            const index = i + completedFiles.length;
            const id = descriptor.key + activeRecord.id + index + new Date().getTime();
            // add extra file meta
            const file = this.setFileMeta({
                id: id,
                filename: rawFile.name,
                contentType: rawFile.type,
                size: rawFile.size,
                _data: rawFile,
                _index: index
            });

            Dispatcher.dispatch({
                type: FileUploadActions.QUEUED,
                recordKey: activeRecord.entityKey,
                recordId: activeRecord.id,
                fieldKey: descriptor.key,
                file,
            });
        }
    }

    onFilePreview(e, d, file, index) {
        previewFile(file.model);
    }

    onRemoveFile(e, d, file, index) {
        const { activeRecord, descriptor } = this.props;
        if(file.status === Hybrid.FileInfo.FILEUPLOADSTATES.COMPLETE) {
            const files = this.getCompletetedFiles();
            const fileIndex = _.findIndex(files, (f) => f.id === file.model.id);
            files.splice(fileIndex, 1);
            this.onCommitChange(descriptor, files.length ? files : null );
        }
        else {
            Dispatcher.dispatch({
                type: FileUploadActions.CANCEL,
                recordKey: activeRecord.entityKey,
                recordId: activeRecord.id,
                fieldKey: descriptor.key,
                file: file.model,
            });
        }
    }

    render() {
        const {activeRecord, descriptor, readOnly} = this.props;
        const config = descriptor.config || {};
        // connect to FileUploadStore
        return <ConnectedControl {...this.getPlumbingProps()}
                        value={activeRecord.get(descriptor.key)}
                        readOnly={readOnly}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
                        multiValued={!!config.multiValued}
                        onFileOpen={this.onFilePreview}
                        onFileRemove={this.onRemoveFile}
                        onFileUpload={this.onFileUpload}
                        // for ConnectedControl to call
                        buildFiles={this.buildFiles}
        />;
    }
}

const ConnectedControl = props => {
    const state = useFluxStore(() => ({
        files: props.buildFiles(),
    }), [
        FileUploadStore,
    ], [props]);
    return <Control {...props} {...state} />;
};

ConnectedControl.propTypes = {
    buildFiles: PropTypes.func.isRequired,
};

FileFieldmanager.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes({
        multiValued: PropTypes.bool,
        readOnly: PropTypes.bool,
    }))
};

export default FileFieldmanager;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/FileField/manager.js